import DevicesError from 'features/join/publisher/DevicesError';
import JoinPreview, { PreviewProps } from 'features/join/publisher/JoinPreview';
import { JoinScreenWrapper } from 'features/join/styles';
import Intro from 'features/join/shared/Intro';
import PendingMediaNotice from 'features/join/shared/PendingMediaNotice';
import { BroadcastMediaStatus } from 'utils/broadcast-setup';

type DevicesSelectionProps = {
  joinWithoutDevices: () => void;
  onReload: () => void;
  onJoinWithoutMedia: () => void;
  status: BroadcastMediaStatus;
} & PreviewProps;

const JoinPublisherLayout = ({
  status,
  joinWithoutDevices,
  onReload,
  onJoinWithoutMedia,
  ...props
}: DevicesSelectionProps) => (
  <JoinScreenWrapper>
    {status === 'prompt' && <Intro />}
    {status === 'stalled' && (
      <PendingMediaNotice onReload={onReload} onJoinWithoutMedia={onJoinWithoutMedia} />
    )}
    {(status === 'failure' || status === 'denied') && (
      <DevicesError joinWithoutDevices={joinWithoutDevices} status={status} />
    )}
    {status === 'success' && <JoinPreview {...props} />}
  </JoinScreenWrapper>
);
export default JoinPublisherLayout;
